import Lottie from 'lottie-react';
import styled from 'styled-components';
import loadingAnimation from 'src/assets/animations/select_spinner.json';

export const LoadingSpinner = (props: { size?: string }) => {
  const { size = '16px' } = props;

  return (
    <Lottie
      animationData={loadingAnimation}
      loop={true}
      style={{ height: size, width: size }}
    />
  );
};

export const NoScrollOverlay = styled.span`
  height: 100%;
  left: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1;
`;
